import { Component } from '@angular/core';
import { RepositoryService } from '../../../smoothr-web-app-core/services/repository/repository.service';
import { SignInPage } from '../../pages/sign-in/sign-in.page';
import { Router } from '@angular/router';
import { SignUpPage } from '../../pages/sign-up/sign-up.page';
import { PopoverController } from '@ionic/angular';
import { HomePage } from '../../pages/home/home.page';
import { MyOrdersPage } from '../../pages/my-orders/my-orders.page';
import { AccountPage } from '../../pages/account/account.page';
import { PrivacyPage } from '../../pages/privacy/privacy.page';
import { TosPage } from '../../pages/tos/tos.page';
import { ImpressumPage } from '../../pages/impressum/impressum.page';
import { MatSnackBar } from '@angular/material/snack-bar';
import RepositoryDirective from '../../../smoothr-web-app-core/directives/repository-directive';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';
import { NavigationService } from 'src/app/services/navigation.service';
import { BrowserLanguageService } from '../../services/geo-language.service';

enum Language {
	GreatBritain = 'en',
	German = 'de',
}
@Component({
	selector: 'app-menu-popover',
	templateUrl: './menu-popover.component.html',
	styleUrls: ['menu-popover.component.scss'],
})
export class MenuPopoverComponent extends RepositoryDirective {
	environment = environment;
	languageEnum = Language;
	constructor(
		public repository: RepositoryService,
		private router: Router,
		private popoverCtrl: PopoverController,
		private snackbarCtrl: MatSnackBar,
		public translate: TranslateService,
		private navigationService: NavigationService,
		private browserLanguageService: BrowserLanguageService
	) {
		super(repository);
	}

	async signIn() {
		await this.popoverCtrl.dismiss();
		await this.navigationService.signIn();
	}

	async signUp() {
		await this.popoverCtrl.dismiss();
		await this.navigationService.signUp();
	}

	async mySpace() {
		await this.popoverCtrl.dismiss();
		await this.navigationService.account();
	}

	async myOrders() {
		await this.popoverCtrl.dismiss();
		await this.navigationService.myOrders();
	}

	async logout() {
		try {
			this.repository.customerAuth.emit(null);
			this.snackbarCtrl.open(this.translate.instant('menu_popover.logout_success'), null, {
				duration: 2000,
			});
		} catch (e) {
			this.snackbarCtrl.open(this.translate.instant('menu_popover.logout_error'), null, {
				duration: 2000,
			});
		}
		await this.popoverCtrl.dismiss();
	}

	async home() {
		await this.popoverCtrl.dismiss();
		await this.navigationService.home();
	}

	async privacy() {
		await this.popoverCtrl.dismiss();
		window.open('/assets/datenschutz.pdf', '_blank');
	}

	async tos() {
		await this.popoverCtrl.dismiss();
		window.open('/assets/agb.pdf', '_blank');
	}

	async impressum() {
		await this.popoverCtrl.dismiss();
		window.open('/assets/Impressum_LinzPro.pdf', '_blank');
	}

	dismiss() {
		this.popoverCtrl.dismiss();
	}
	changeLang(language: string) {
		this.browserLanguageService.changeLanguage(language);
	}
}
